module.exports = __webpack_public_path__ + "static/media/tiger-lady.d8eb4a89.jpeg";